import axios from 'axios';
import authService from '../services/authService';

export const referralGuidKey = 'referralGuid';

const http = axios.create({
    baseURL: `${authService.getCaseManagerBasePath()}/api`
});

export const getUniqueId = () => {
    return authService.getToken()
        .then((authResponse) => {
            return http.get('/referrals/referralguid', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authResponse.data.access_token}`
                }
            });
        });
};

export const getMaxUploadSizeInMB = () => {
    return authService.getToken()
        .then((authResponse) => {
            return http.get('/referrals/GetMaxUploadSizeInMB', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authResponse.data.access_token}`
                }
            });
        });
};

export const upload = (referralGuid, item, onUploadProgress) => {
    return authService.getToken()
        .then((authResponse) => {
            let formData = new FormData();
            formData.append('file', item.file);

            return http.post(`/referrals/${referralGuid}/files`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authResponse.data.access_token}`
                },
                onUploadProgress,
            });
        });
};

export const deleteFile = (referralGuid, fileId) => {
    return authService.getToken()
        .then((authResponse) => {
            return http.delete(`/referrals/${referralGuid}/files/${fileId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authResponse.data.access_token}`
                }
            });
        });
};
